var GrouponValidate;

GrouponValidate = {
  email: function(value) {
    var emailInvalidRegex, emailValidRegex, invalidMatch, validMatch;
    if ((value == null) || value.length > 100) {
      return false;
    }
    emailValidRegex = "^((\\\"[^\\\"\\f\\n\\r\\t\\v\\b]+\\\")|([\\.\\w=\\!\\#\\$\\%\\&\\'\\*\\+\\-\\~\\/\\^\\`\\|\\{\\}]+))@((\\[(((25[0-5])|(2[0-4][0-9])|([0-1]?[0-9]?[0-9]))\\.((25[0-5])|(2[0-4][0-9])|([0-1]?[0-9]?[0-9]))\\.((25[0-5])|(2[0-4][0-9])|([0-1]?[0-9]?[0-9]))\\.((25[0-5])|(2[0-4][0-9])|([0-1]?[0-9]?[0-9])))\\])|(((25[0-5])|(2[0-4][0-9])|([0-1]?[0-9]?[0-9]))\\.((25[0-5])|(2[0-4][0-9])|([0-1]?[0-9]?[0-9]))\\.((25[0-5])|(2[0-4][0-9])|([0-1]?[0-9]?[0-9]))\\.((25[0-5])|(2[0-4][0-9])|([0-1]?[0-9]?[0-9])))|((([A-Za-z0-9\\-])+\\.)+[A-Za-z\\-]+))$";
    validMatch = new RegExp(emailValidRegex);
    emailInvalidRegex = "<|`";
    invalidMatch = new RegExp(emailInvalidRegex);
    return validMatch.test(value) && !invalidMatch.test(value);
  },
  zip: function(value) {
    var regexp, zip;
    if (value === '' || value === 'undefined') {
      return false;
    }
    zip = $.trim(value);
    regexp = /(^([0-9]{5}(-[0-9]{4})?)$)|(^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1} *\d{1}[A-Za-z]{1}\d{1}$)/;
    return regexp.test(zip);
  },
  phone: function(value) {
    var phone, regExp;
    if (value.length === 0) {
      return false;
    }
    phone = $.trim(value);
    regExp = /^(?:\d{3}|\(\d{3}\))(?: *|-?)\d{3}(?: *|-?)\d{4}$/;
    return regExp.test(phone);
  },
  phoneInternational: function(value) {
    var phone, regExp, regExp1;
    if (value.length === 0) {
      return false;
    }
    phone = $.trim(value);
    regExp = /^[0-9]+$/;
    if (regExp.test(phone)) {
      return true;
    }
    regExp = /(?=^[\( *\-*\) *0-9+]*$)(?=^(?!\-+))(?=\((\d{1,} *\d{0,})\)|\((\d{1,}\-*\d{0,})\)|\((\d{1,})\))/m;
    regExp1 = /^[ *\-* *0-9+]*$/;
    if (regExp.test(phone)) {
      return true;
    } else {
      return regExp1.test(phone);
    }
  },
  creditCard: function(value) {
    var description, regExp;
    if (value.length === 0) {
      return false;
    }
    description = $.trim(value);
    regExp = /(cc#\s|credit\scard\s|Visa\s|visa\s|mastercard\s|Mastercard\sAmerican\s|american\sJCB\s|jcb\s|Discover\s|discover\s)((?:(?:4\d{3})|(?:5[1-5]\d{2})|6(?:011|5[0-9]{2}))(?:-?|\s*)(?:\d{4}(?:-?|\s*)){3}|(?:3[4,7]\d{2})(?:-?|\s*)\d{6}(?:-?|\s*)\d{5}|(?:2131|1800|3088|3337|3096\d{11})|((35\d{2}-?\s?)(\d{4}(-?\s?))))/;
    return regExp.test(description);
  }
};

module.exports = GrouponValidate;

//# sourceMappingURL=data:application/json;base64,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
